var GrouponValidate;

GrouponValidate = {
  email: function(value) {
    var emailInvalidRegex, emailValidRegex, invalidMatch, validMatch;
    if ((value == null) || value.length > 100) {
      return false;
    }
    emailValidRegex = "^((\\\"[^\\\"\\f\\n\\r\\t\\v\\b]+\\\")|([\\.\\w=\\!\\#\\$\\%\\&\\'\\*\\+\\-\\~\\/\\^\\`\\|\\{\\}]+))@((\\[(((25[0-5])|(2[0-4][0-9])|([0-1]?[0-9]?[0-9]))\\.((25[0-5])|(2[0-4][0-9])|([0-1]?[0-9]?[0-9]))\\.((25[0-5])|(2[0-4][0-9])|([0-1]?[0-9]?[0-9]))\\.((25[0-5])|(2[0-4][0-9])|([0-1]?[0-9]?[0-9])))\\])|(((25[0-5])|(2[0-4][0-9])|([0-1]?[0-9]?[0-9]))\\.((25[0-5])|(2[0-4][0-9])|([0-1]?[0-9]?[0-9]))\\.((25[0-5])|(2[0-4][0-9])|([0-1]?[0-9]?[0-9]))\\.((25[0-5])|(2[0-4][0-9])|([0-1]?[0-9]?[0-9])))|((([A-Za-z0-9\\-])+\\.)+[A-Za-z\\-]+))$";
    validMatch = new RegExp(emailValidRegex);
    emailInvalidRegex = "<|`";
    invalidMatch = new RegExp(emailInvalidRegex);
    return validMatch.test(value) && !invalidMatch.test(value);
  },
  zip: function(value) {
    var regexp, zip;
    if (value === '' || value === 'undefined') {
      return false;
    }
    zip = $.trim(value);
    regexp = /(^([0-9]{5}(-[0-9]{4})?)$)|(^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1} *\d{1}[A-Za-z]{1}\d{1}$)/;
    return regexp.test(zip);
  },
  phone: function(value) {
    var phone, regExp;
    if (value.length === 0) {
      return false;
    }
    phone = $.trim(value);
    regExp = /^(?:\d{3}|\(\d{3}\))(?: *|-?)\d{3}(?: *|-?)\d{4}$/;
    return regExp.test(phone);
  },
  phoneInternational: function(value) {
    var phone, regExp, regExp1;
    if (value.length === 0) {
      return false;
    }
    phone = $.trim(value);
    regExp = /^[0-9]+$/;
    if (regExp.test(phone)) {
      return true;
    }
    regExp = /(?=^[\( *\-*\) *0-9+]*$)(?=^(?!\-+))(?=\((\d{1,} *\d{0,})\)|\((\d{1,}\-*\d{0,})\)|\((\d{1,})\))/m;
    regExp1 = /^[ *\-* *0-9+]*$/;
    if (regExp.test(phone)) {
      return true;
    } else {
      return regExp1.test(phone);
    }
  },
  creditCard: function(value) {
    var description, regExp;
    if (value.length === 0) {
      return false;
    }
    description = $.trim(value);
    regExp = /(cc#\s|credit\scard\s|Visa\s|visa\s|mastercard\s|Mastercard\sAmerican\s|american\sJCB\s|jcb\s|Discover\s|discover\s)((?:(?:4\d{3})|(?:5[1-5]\d{2})|6(?:011|5[0-9]{2}))(?:-?|\s*)(?:\d{4}(?:-?|\s*)){3}|(?:3[4,7]\d{2})(?:-?|\s*)\d{6}(?:-?|\s*)\d{5}|(?:2131|1800|3088|3337|3096\d{11})|((35\d{2}-?\s?)(\d{4}(-?\s?))))/;
    return regExp.test(description);
  }
};

module.exports = GrouponValidate;

//# sourceMappingURL=data:application/json;base64,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
